/**
 * Opens the Reloadify newsletter popup from an ordinary link in page content.
 *
 * Reloadify ships its own manual trigger (class="reloadify_popup_trigger"), but it
 * never calls preventDefault, so a real <a href> navigates away before the popup
 * opens. This handler lets editors write a normal link to "#newsletter" instead.
 *
 * Requires the matching Reloadify popup to use the "manual" show type: that is the
 * only type whose should_display_popup() skips the once-per-visitor gate, and the
 * popup must win the URL match for the current page so its HTML is loaded.
 */
(function () {
  var TRIGGER_SELECTOR = 'a[href$="#newsletter"]';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();

    var reloadify = window.rm;
    if (!reloadify || !reloadify.popup || typeof reloadify.show_popup !== 'function') return;

    reloadify.show_popup();
  });
})();
